import axios, {AxiosResponse} from 'axios'
import {
  ManualExamMeasurementCenterDetail,
  ManualExamMeasurementCenterExamTypeOption,
  ManualExamMeasurementCenterListItem,
  ManualExamMeasurementCenterSemesterOption,
  ManualExamSharedCourseDeleteRequest,
  ManualExamSharedCourseGroup,
  ManualExamSharedCourseSaveRequest,
} from './_models'
import type {ManualExamStatus} from '../../my-course-exam/manual/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const CUSTOM_URL = `${API_URL}/Custom`

type MeasurementCenterManualExamListParams = {
  semesterId: number
  examTypeId?: number | null
  status?: ManualExamStatus | 'All' | null
}

export const getMeasurementCenterManualExams = async (
  params: MeasurementCenterManualExamListParams
) => {
  const queryParams: Record<string, number | string> = {
    semesterId: params.semesterId,
  }

  if (typeof params.examTypeId === 'number' && Number.isFinite(params.examTypeId)) {
    queryParams.examTypeId = params.examTypeId
  }

  if (params.status && params.status !== 'All') {
    queryParams.status = params.status
  }

  return axios
    .get(`${CUSTOM_URL}/GetMeasurementCenterManualExams`, {params: queryParams})
    .then((res: AxiosResponse<{data?: ManualExamMeasurementCenterListItem[]}>) => res.data?.data ?? [])
}

export const getMeasurementCenterManualExamSemesters = async () => {
  return axios
    .get(`${CUSTOM_URL}/GetSemesters`)
    .then(
      (res: AxiosResponse<ManualExamMeasurementCenterSemesterOption[]>) => res.data ?? []
    )
}

export const getMeasurementCenterManualExamTypes = async (semesterId: number) => {
  return axios
    .get(`${CUSTOM_URL}/GetMeasurementCenterManualExamTypes`, {params: {semesterId}})
    .then(
      (res: AxiosResponse<{data?: ManualExamMeasurementCenterExamTypeOption[]}>) =>
        res.data?.data ?? []
    )
}

export const getMeasurementCenterManualExamDetail = async (examId: number) => {
  return axios
    .get(`${CUSTOM_URL}/GetMeasurementCenterManualExamDetail`, {params: {examId}})
    .then((res: AxiosResponse<{data?: ManualExamMeasurementCenterDetail}>) => res.data?.data ?? null)
}

export const getManualExamSharedCourses = async (examId: number) => {
  return axios
    .get(`${CUSTOM_URL}/GetManualExamSharedCourses`, {params: {examId}})
    .then((res: AxiosResponse<{data?: ManualExamSharedCourseGroup}>) => res.data?.data ?? null)
}

export const saveManualExamSharedCourses = async (payload: ManualExamSharedCourseSaveRequest) => {
  return axios.post(`${CUSTOM_URL}/SaveManualExamSharedCourses`, payload)
}

export const deleteManualExamSharedCourse = async (payload: ManualExamSharedCourseDeleteRequest) => {
  return axios.post(`${CUSTOM_URL}/DeleteManualExamSharedCourse`, payload)
}
